import { Link } from 'react-router-dom';
import SectionHeading from '../components/SectionHeading';
import ContactDetails from '../components/ContactDetails';
import ContactForm from '../components/ContactForm';
import LocationMap from '../components/LocationMap';
import SafeIcon from '../common/SafeIcon';

export default function Contact() {
  return (
    <main>
      <section className="page-hero page-hero-contact">
        <div className="page-width">
          <span className="eyebrow">We’d love to hear from you</span>
          <h1>Contact Us</h1>
          <p>Get in touch for enquiries or to plan your stay.</p>
        </div>
      </section>
      <section className="contact-page-section section-pad page-width">
        <div className="contact-page-copy">
          <SectionHeading
            eyebrow="Get in touch"
            title="We’re happy to help"
            description="Reach out with a question or to talk through your plans."
          />
          <ContactDetails />
          <Link className="button button-outline" to="/booking">
            Ask about a stay <SafeIcon name="ArrowRight" />
          </Link>
        </div>
        <ContactForm />
      </section>
      <section className="page-width">
        <LocationMap className="contact-page-map" />
      </section>
    </main>
  );
}